module.exports = __webpack_public_path__ + "static/media/chatMessageSending_1.5dfb11f4.mp3";